<template>

<portal to="top">

<div class="bar" v-bind:class="{'is-inline': inline, 'with-scroll': withScroll, 'has-scrolled': hasScrolled, 'is-community': $route.meta.isCommunity}">

	<div class="inner">

		<slot></slot>

	</div>

</div>

</portal>

</template>

<script>

export default {

	props: ['inline', 'withScroll'],

	data: function() {
		
		return {
			hasScrolled: false
		}

	},

	created: function() {

		this.$pubsub.$on('content.scroll', this.onContentScroll.bind(this))

	},

	beforeDestroy: function() {

		this.$pubsub.$off('content.scroll', this.onContentScroll.bind(this))

	},

	methods: {

		onContentScroll: function(e) {

			this.hasScrolled = e > 24

		}

	}

}

</script>

<style scoped>

.bar {
	width: 100%;
	position: fixed;
	left: 384px;
	top: 0px;
	height: 64px;
	padding: 0px 20px;
	width: calc(100% - 384px);
	background-color: #fff;
	z-index: 2000;
	transition: margin-left 100ms linear;
}

.is-desktop .bar.with-scroll.has-scrolled {
	box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
}

.is-mobile .bar {
	background-color: transparent;
}

.bar:empty {
	display: none;
}

.bar.is-community {
	left: 0px;
	width: 100%;
}

.is-smaller .bar {
	left: 64px;
	width: calc(100% - 64px);
	height: 64px;
}

.is-mobile .bar {
	right: 10px;
	position: fixed;
	top: 4px;
	left: auto;
	padding: 0px;
	height: 40px;
	width: auto;
	transition: none;
	z-index: 300000001;
}

.is-mobile .bar.is-community {
	top: 40px;
}

.bar.is-inline {
	position: relative;
	top: 0px;
}

.bar .inner {
	display: flex;
	justify-content: space-between;
	padding: 0px;
}

</style>
